
import length from '@turf/length';
import * as L from 'leaflet';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import RenderColors from '../services/colors';
import { useMissionsStore } from '../stores/missionsStore';
import { IPolylineOptions } from '../models/IPolylineOptions';

@Component({ name: 'LeafletMapPolyline' })
export default class LeafletMapPolyline extends Vue {
  @Prop() map!: L.Map;
  @Prop() layer!: L.LayerGroup | L.Map;
  @Prop() polyline!: IPolylineOptions;

  mapPolyLine = null as L.Polyline | null;
  missionStore = useMissionsStore();
  startMarker: L.Marker | null = null;
  endMarker: L.Marker | null = null;

  destroyed() {
    this.mapPolyLine?.remove();
    this.startMarker?.remove();
    this.endMarker?.remove();
  }

  mounted() {
    this.mapPolyLine = new L.Polyline(
      this.polyline.Location as L.LatLngExpression[] | L.LatLngExpression[][],
      this.polyline.Options
    )
      .addTo(this.map)
      .bringToFront();
    this.updatePathLengthAndMarkers();
  }

  @Watch('polyline')
  onLineChange() {
    if (this.mapPolyLine) {
      this.mapPolyLine.setLatLngs(this.polyline.Location as L.LatLngExpression[] | L.LatLngExpression[][]);
      this.mapPolyLine.setStyle(this.polyline.Options);
    }
    if (this.startMarker) this.startMarker.remove();
    if (this.endMarker) this.endMarker.remove();
    this.updatePathLengthAndMarkers();
  }

  updatePathLengthAndMarkers() {
    if (this.mapPolyLine == undefined) return;
    if (
      this.polyline.Options.color == RenderColors.PlannedPath ||
      this.polyline.Options.color == RenderColors.Leader ||
      this.polyline.Options.color == RenderColors.Follower
    ) {
      const pathLengthKm = length(this.mapPolyLine.toGeoJSON(), { units: 'kilometers' });
      this.missionStore.setPathLengthKm(pathLengthKm);

      if (this.startMarker) this.startMarker.remove();
      if (this.endMarker) this.endMarker.remove();

      const points = this.mapPolyLine.getLatLngs() as L.LatLng[];

      if (this.mapPolyLine.isEmpty()) return;

      const firstPoint = points[0];
      this.startMarker = new L.Marker(firstPoint, {
        icon: this.generateMarkerIcon('M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z')
      });
      this.startMarker?.addTo(this.map);

      const lastPoint = points.slice(-1)[0];

      this.endMarker = new L.Marker(lastPoint, { icon: this.generateMarkerIcon('M18,18H6V6H18V18Z') });
      this.endMarker?.addTo(this.map);
    }
  }

  generateMarkerIcon(path: string) {
    const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    iconSvg.setAttribute('fill', 'white');
    iconSvg.setAttribute('stroke', 'black');

    iconPath.setAttribute('d', path);

    iconSvg.appendChild(iconPath);

    const icon = new XMLSerializer().serializeToString(iconSvg);

    return new L.Icon({ iconUrl: `data:image/svg+xml,${icon}`, iconSize: [24, 24], iconAnchor: [12, 12] });
  }
}
